<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')">
            <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/system/create-country"><i class="fas fa-plus"></i> {{ "CREATE_COUNTRY" | translate | titlecase }}</button>
        </div>

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "COUNTRIES_MANAGMENT" | translate | titlecase }}</h5>

                <app-loader [show]="showLoader"></app-loader>

                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <table *ngIf="countries.length >= 1" class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th>{{ "COUNTY_NAME_AR" | translate | titlecase }}</th>
                                <th>{{ "COUNTY_NAME_EN" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">{{ "COUNTY_MODIFY" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey"*ngIf="globals.checkUserHasPermission('COUNTRIES - DELETE')">{{ "COUNTRY_DELETE" | translate | titlecase }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of countries">
                                <td>{{res?.countryNameAr}}</td>
                                <td>{{res?.countryNameEn}}</td>
                                <td class="text-bold text-warning" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">
                                    <button class="btn btn-sm btn-link text-warning" (click)="editCountry(res?.id)"><i
                                            class="fas fa-edit"></i>
                                            {{ "MODIFY" | translate | titlecase }}</button>
                                </td>
                                <td class="text-bold text-danger" *ngIf="globals.checkUserHasPermission('COUNTRIES - DELETE')">
                                    <button class="btn btn-sm btn-link text-danger" data-toggle="modal"
                                        data-target="#deleteModal" (click)="getCurrentCountry(res?.id)"><i
                                            class="fas fa-trash"></i>
                                            {{ "DELETE" | translate | titlecase }}</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


    </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <i class="fas fa-trash text-danger"></i>
                </div>
                <div class="p-2"><b>{{ "DELETE" | translate | titlecase }}</b> {{currentCountryName}}?</div>

                <a type="button" class="btn btn-link text-danger" (click)="deleteCountry(currentCountryId)">{{ "YES_DELETE_IT" | translate | titlecase }}
                    </a>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>